/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {validateEmploymentPasscode} from '../api'

export const useMutationValidateEmploymentPasscode = createReactQueryMutationHook('validateEmploymentPasscode', validateEmploymentPasscode)
